import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum ProductSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName'
}

export enum ProductFilterFields {
	includeInactive = 'includeInactive'
}

export type IsUsedInItemEntity = Entity & {
	isUsedInItem: boolean
}

export declare namespace Product {
	interface Basic extends Entity {
		isActive: boolean
	}

	interface Detailed {
		id: number
		name: string
		description: string
		isActive: boolean
		productStates: IsUsedInItemEntity[]
		productTypes: IsUsedInItemEntity[]
	}

	namespace Form {
		interface Generic {
			name: string | null
			description: string | null
			isActive: boolean
			productStates: LabelValue<number>[]
			productTypes: LabelValue<number>[]
		}
	}
	namespace Request {
		interface Generic {
			name: string | null
			description: string | null
			isActive: boolean
			productStates: number[]
			productTypes: number[]
		}
	}
	namespace Search {
		interface Config {
			[ProductSearchFields.searchById]: ConfigItem<ProductSearchFields>
			[ProductSearchFields.searchByName]: ConfigItem<ProductSearchFields>
		}
		interface Result {
			[ProductSearchFields.searchById]: Entity[]
			[ProductSearchFields.searchByName]: Entity[]
		}
	}
	namespace Filter {
		interface Config {
			[ProductFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}
}
